import React from "react";
import Iconbreadcrumb from "../../../Assets/Icons/Iconbreadcrumb.png";
import './style.css';

const Breadcrumb = ({
  contents = [
    {
      name: "Dashboard",
      url: "dashboard",
    }
  ],
}) => {
  return (
    <div className="breadcrumb-frame">
      {contents.map((item, index) => (
        <React.Fragment key={index}>
          <a
            className={
              item.url
                ? "breadcrumb-text blue"
                : "breadcrumb-text dark-grey"
            } href={item.url}
          >{item.name}</a>
          {index < contents.length - 1 && (
            <React.Fragment>
              <img className="breadcrumb-icon" alt="breadcrumb-icon" src={Iconbreadcrumb} />
            </React.Fragment>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
